/******************************
 * GENERATED FILE, DO NOT EDIT *
 *******************************/ import type {
  ReactNode,
  SVGProps,
} from "react";
export default function IconCrossCircle(
  props: SVGProps<SVGSVGElement>
): ReactNode {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16px"
      height="16px"
      fill="none"
      viewBox="0 0 16 16"
      color="currentColor"
      {...props}
    >
      <circle cx={8} cy={8} r={7.4} stroke="currentColor" strokeWidth={1.2} />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeMiterlimit={10}
        strokeWidth={1.2}
        d="m11 5-6 6M5 5l6 6"
      />
    </svg>
  );
}
